module.exports = __webpack_public_path__ + "assets/media/defaultIcon.f02d5b7c.svg";